import { Drawer, IconButton, Typography, Box, Divider, Button } from "@mui/material";
import { motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const MotionBox = motion(Box);

export default function AssessmentViewDrawer({ open, onClose, data }) {
  const [showAllQuestions, setShowAllQuestions] = useState(false);

  const questionsToShow = showAllQuestions ? data?.questions : data?.questions?.slice(0, 2);

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <MotionBox
        initial={{ x: 300 }}
        animate={{ x: 0 }}
        exit={{ x: 300 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        sx={{ width: 400, p: 2, maxHeight: "100vh", overflowY: "auto" }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center"
         sx={{
          mt: { xs: 8, sm: 8, md: 0 }, // ✅ mt=2 only for xs, 0 for sm and above
        }}
        >
          <Typography variant="h6">Assessment Details</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: 'red' }} />
          </IconButton>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" fontWeight="bold">Title:</Typography>
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{ __html: data?.title || "" }}
        />

        <Typography variant="subtitle2" mt={2} fontWeight="bold">Description:</Typography>
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{ __html: data?.description || "" }}
        />

        <Typography variant="subtitle2" mt={2} fontWeight="bold">Total Marks: {data?.total_marks}</Typography>
        <Typography variant="subtitle2" fontWeight="bold">Total Questions: {data?.total_questions}</Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" fontWeight="bold">Questions</Typography>
        {questionsToShow?.map((q) => (
          <Box key={q.id} mt={2} p={1} border="1px solid #ddd" borderRadius={2}>
            <Typography variant="subtitle2">
              {q.sort_order}.{" "}
              <span dangerouslySetInnerHTML={{ __html: q.question_text }} />
            </Typography>
            <Typography variant="body2">
              Marks: {q.marks} | Negative: {q.negative_marks}
            </Typography>

            {q.question_type === "text" && (
              <>
                <Typography fontWeight="bold" mt={1}>Answer:</Typography>
                <Typography
                  dangerouslySetInnerHTML={{ __html: q.answer_text || "—" }}
                />
              </>
            )}

            {q.options?.length > 0 && (
              <>
                <Typography fontWeight="bold" mt={1}>Options:</Typography>
                {q.options.map((opt) => (
                  <Typography key={opt.id} sx={{ ml: 1 }}>
                    ➤ {opt.option_text} {opt.is_correct ? "(✔)" : ""}
                  </Typography>
                ))}
              </>
            )}
          </Box>
        ))}

        {data?.questions?.length > 2 && (
          <Box textAlign="center" mt={2}>
            <Button onClick={() => setShowAllQuestions((prev) => !prev)}>
              {showAllQuestions ? "Show Less" : "Show More"}
            </Button>
          </Box>
        )}
      </MotionBox>
    </Drawer>
  );
}
